import {
    Page,
    Stack,
    ResourceList,
    ResourceItem,
    Layout,
    Card,
    PageActions,
    SkeletonBodyText,
    Badge,
    Button,
    Toast,
    Icon,
    Link
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../common/Helpers';
import { getRuleDefinitionByType } from '../../rules/TagRuleDefinitions';
import React, { Component } from 'react'
import { Helmet } from 'react-helmet';
import Cookies from "js-cookie";
import {
    RefreshMajor
} from '@shopify/polaris-icons';

class TagRuleViewPage extends Component {

    constructor(props) {
        super(props)

        const { params } = this.props.match;
        this.shopOrigin = Cookies.get("shopOrigin");

        this.state = {
            loading: true,
            loadingExecutions: true,
            executingRule: false,
            id: params.id,
            rule: null,
            executions: [],
            executionsSkip: 0,
            executionsTake: 100,
            manuallyExecutedToastActive: false
        };
    }

    toggleToast = () => {
        this.setState({
            manuallyExecutedToastActive: !this.state.manuallyExecutedToastActive
        })
    }

    render() {

        if (this.state.loading)
            return <SkeletonBodyText lines="20" />;

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Tag Rule</title>
                </Helmet>
                <Page
                    title={this.state.rule.name}
                    primaryAction={{ content: 'Edit', onAction: this.handleEdit }}
                    secondaryActions={[{ content: 'Manually Execute Rule', disabled: this.state.rule.isExecuting, loading: this.state.executingRule, onAction: this.handleExecuteRule },
                    ]}
                    breadcrumbs={[{ content: 'Tag Rules', url: '/tag-rules' }]}
                >
                    {this.state.manuallyExecutedToastActive &&
                        <Toast content="Execution scheduled" onDismiss={this.toggleToast} />
                    }

                    <Layout fullWidth>
                        <Layout.Section>
                            {this.state.rule.isExecuting && <Badge status='attention'>Executing</Badge>}
                        </Layout.Section>
                        <Layout.Section>
                            <Card title="Executions"
                                actions={[{
                                    content: <Button onClick={this.handleRefresh} outline size="medium" icon={<Icon source={RefreshMajor} />}></Button>
                                }]}
                                secondaryFooterActions={[
                                ]}>
                                <Card.Section>
                                    <p>List of latest changes that were triggered by this rule:</p>
                                </Card.Section>
                                <ResourceList
                                    loading={this.state.loadingExecutions}
                                    resourceName={{ singular: 'execution', plural: 'executions' }}
                                    items={this.state.executions}
                                    renderItem={this.renderExecutionItem}
                                />
                            </Card>
                        </Layout.Section>
                    </Layout>
                    <PageActions
                        secondaryActions={[
                            {
                                content: 'Delete rule',
                                onAction: this.handleDelete,
                                destructive: true,
                            },
                        ]}
                    />
                </Page>
            </div>
        );
    }

    renderExecutionItem = (item) => {
        const { description, id, status, dateCreated } = item;

        var resourceType = "Resource";
        var resourceLegacyId = "Link";
        var resourceUrl = "";

        if (description.resourceId.startsWith("gid://shopify/Product/")) {
            resourceType = "Product";
            resourceLegacyId = description.resourceId.replace("gid://shopify/Product/", "");
            resourceUrl = `https://${this.shopOrigin}/admin/products/${resourceLegacyId}`;
        }

        if (description.resourceId.startsWith("gid://shopify/Customer/")) {
            resourceType = "Customer";
            resourceLegacyId = description.resourceId.replace("gid://shopify/Customer/", "");
            resourceUrl = `https://${this.shopOrigin}/admin/customers/${resourceLegacyId}`;
        }

        if (description.resourceId.startsWith("gid://shopify/Order/")) {
            resourceType = "Order";
            resourceLegacyId = description.resourceId.replace("gid://shopify/Order/", "");
            resourceUrl = `https://${this.shopOrigin}/admin/orders/${resourceLegacyId}`;
        }

        if (description.resourceId.startsWith("gid://shopify/ProductVariant/")) {
            resourceType = "Product Variant";
            resourceLegacyId = description.resourceId.replace("gid://shopify/ProductVariant/", "");
            resourceUrl = `https://${this.shopOrigin}/admin/variants/${resourceLegacyId}`;
        }

        var date = new Date(Date.parse(dateCreated));

        return (
            <ResourceItem id={id} url={null} onClick={null}>
                <Stack>
                    <Stack.Item>
                        {date.toLocaleString()}
                    </Stack.Item>
                    <Stack.Item>
                        {status === "Pending" && <div>
                            <Badge status="warning">Pending</Badge>
                        </div>}
                        {status === "Error" && <div>
                            <Badge status="critical">Error</Badge>
                        </div>}
                        {status === "Completed" && <div>
                            <Badge status="success">Completed</Badge>
                        </div>}
                    </Stack.Item>
                    <Stack.Item>
                        <Badge status="info">{description.action}</Badge>
                    </Stack.Item>
                    <Stack.Item>
                        {description.actionObject}
                    </Stack.Item>
                    <Stack.Item>
                        {description.link}
                    </Stack.Item>
                    <Stack.Item>
                        <Badge status="new">{resourceType}</Badge>
                    </Stack.Item>
                    <Stack.Item>
                        <Link url={resourceUrl} external={true}>{resourceLegacyId}</Link>
                    </Stack.Item>
                </Stack>
            </ResourceItem >
        );
    }

    handleDelete = () => {

        fetch(`api/tagRules/${this.state.id}`, {
            method: 'DELETE'
        }).then(() => {
            this.props.history.push("/tag-rules");
        });
    }

    handleRefresh = () => {
        this.fetchExecutions();
    }

    handleEdit = () => {

        const ruleDefinition = getRuleDefinitionByType(this.state.rule.type);

        if (ruleDefinition.legacy) {
            this.props.history.push(`/tag-rules/edit/${this.state.rule.type}/${this.state.rule.id}`);
        }
        else {
            this.props.history.push(`/tag-rules/modify/${this.state.rule.id}`);
        }

    }

    handleExecuteRule = () => {
        this.executeRule();
    }

    executeRule = () => {

        this.setState({
            executingRule: true
        })

        fetch(`api/tagRules/${this.state.id}/execution`, {
            method: 'POST'
        })
            .then(response => {
                this.setState({
                    executingRule: false
                });
                this.fetchRuleData();
                this.toggleToast();
            });
    }

    fetchRuleData = () => {
        fetch(`api/tagRules/info/${this.state.id}`, {
            method: 'get'
        })
            .then(response => response.json())
            .then(data => this.setState({
                rule: data,
                loading: false
            }));
    }

    fetchExecutions = () => {

        this.setState({
            loadingExecutions: true
        });

        fetch(`api/tagRules/${this.state.id}/executions?skip=${this.state.executionsSkip}&take=${this.state.executionsTake}`, {
            method: 'get'
        })
            .then(response => response.json())
            .then(data => this.setState({
                executions: data,
                loadingExecutions: false
            }));
    }

    componentDidMount() {
        this.fetchRuleData();
        this.fetchExecutions();
    }
}

export default TagRuleViewPage